
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire30ab"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire30ab"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $8229a19424af1f7f$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["gjX5N","index.341986a9.js","0B2Pv","tudor.5298798e.jpg","bBCMu","logo.78ceb79c.jpg","lWvEn","SNG_logo.4f29ac45.jpg","bNXbk","BiseNoire_logo.0ad33550.jpg","9z3Y7","silvaplana-logo.9970afb6.png","4DYgm","trop.32d0c0da.png","8AMu1","icon-1080x1080.e7306df8.png","l0ejr","html2canvas.d96a86fa.js","5zbQZ","purify.0ddba7bd.js","14NDh","index.es.7c1d18cd.js","7QlJ2","logo_certificat.f4cc810b.png","AeUz0","image.4d7aecc5.png","bDA2T","topo.67400651.png","glW1F","outdoor.678aab50.png","eZX5V","smooth.66951eb7.png","elJL8","dark.e46df028.png","66n1L","swissbathy3d.ccd9a4bc.png","GThFu","swissalti3d.4b2b45f7.png","ix8Di","patrouilledesglaciers.01999a0d.png","7RMNE","icao.1e198fa4.png","jOoo7","segelflugkarte.1c82e151.png","8EWlr","swissmilpilotschart.c864dc60.png","9T4tt","winter.36c01db6.png","1gQxP","skitouren.fa3f23e4.png","aY5wI","schneeschuhrouten.0c083464.png","a2jZM","swisstlm3d.48a5382f.png","eZWR4","wanderland.6732514d.png","lcOw5","veloland.934b0e5f.png","1HqyP","mountainbikeland.5a334576.png","ayT1u","landeskarte.735fe130.png","3KWlz","icon-384x384.1168da7d.png","5timE","sw.290ef042.js","kLCmh","index.1b3efa4e.css"]'));


//# sourceMappingURL=index.runtime.4b8101c9.js.map
